// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { B50 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
// some of this css is sourced from TemplateList.tsx in confluence-frontend for consistency
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Title = styled.div({
	marginTop: token('space.negative.050', '-4px'),
	display: '-webkit-box',
	WebkitLineClamp: 2,
	WebkitBoxOrient: 'vertical',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PrimaryTextWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	gap: token('space.050', '4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Description = styled.div({
	marginTop: token('space.050', '4px'),
	display: '-webkit-box',
	WebkitLineClamp: 4,
	WebkitBoxOrient: 'vertical',
	whiteSpace: 'normal',
});

interface CardWrapperProps {
	isActive?: boolean;
	hasTooltip?: boolean;
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const CardWrapper = styled.div<CardWrapperProps>((props) => ({
	position: 'relative',
	marginBottom: token('space.100', '8px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > button': {
		padding: token('space.150', '12px'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		backgroundColor: props.isActive ? token('color.background.selected', B50) : 'initial',
		'&:focus': {
			boxShadow:
				'none' /* legacy batch.css in JFE ends up adding additional box shadow around this, which we don't want */,
		},
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'&.is-disabled': {
		opacity: token('opacity.disabled', '0.5'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		cursor: props.hasTooltip ? 'pointer' : 'auto',
		pointerEvents: 'none',
	},
}));
